export default "__VITE_ASSET__c26ea021__"